import { resolveService } from "@services/service-resolver";
import { realPaymentService } from "./payment.service";
import { mockPaymentService } from "./payment.mock-service";
import type { IPaymentService } from "../types";

export const paymentService: IPaymentService = resolveService(
  realPaymentService,
  mockPaymentService,
);
